import { InjectionToken } from '@angular/core';

/** Configuración inyectada desde `vault-shell` (environment). */
export interface IngestModuleEnv {
  /**
   * Si es true: datos de ejemplo, sin depender del API para maquetar el módulo.
   * Pon `ingestUiMock: false` en environment cuando el backend esté listo.
   */
  previewMode: boolean;
}

/** Debe proveerse en `vault-shell` (`app.config.ts`). */
export const INGEST_MODULE_ENV = new InjectionToken<IngestModuleEnv>('INGEST_MODULE_ENV');
